document.addEventListener("DOMContentLoaded", function () {

  document.querySelectorAll(".advanced-slider").forEach(function(slider){

    const slides = slider.querySelectorAll(".advanced-slide");
    const nextBtn = slider.querySelector(".advanced-next");
    const prevBtn = slider.querySelector(".advanced-prev");

    let current = 0;

    function showSlide(index){
      slides.forEach(slide => {
        slide.classList.remove("active");
      });

      slides[index].classList.add("active");
    }

    nextBtn.addEventListener("click", function(){
      current++;

      if(current >= slides.length){
        current = 0;
      }

      showSlide(current);
    });


    prevBtn.addEventListener("click", function(){
      current--;

      if(current < 0){
        current = slides.length - 1;
      }

      showSlide(current);
    });

  });

});